import { IParamsResolver } from "../interfaces/params.resolver";
import { get, isNumber, join, split } from 'lodash';

export class DotBasedValueResolver {
  constructor(private readonly delegate: IParamsResolver) { }

  resolveParamValue(valueGetter: string, inputs: any, widgetConfig: any) {
    const lookupPath = split(valueGetter, '.');
    let source = null;

    // local_inputs is used to resolve dynamic params from widget.
    // NOTICE: local_inputs not propogate event to inputsParamsChange
    if (lookupPath[0] === 'inputs' || lookupPath[0] === 'local_inputs') {
      source = inputs;
    }
    else if (lookupPath[0] === 'constants') {
      source = widgetConfig.constants;
    }
    else if (lookupPath[0] === 'widget' || lookupPath[0] === 'extension') {
      const remainingPath = join(lookupPath.slice(1), '.');
      return this.delegate.resolve(remainingPath);
    }
    else {
      return null;
    }

    for (let index = 1; index < lookupPath.length; index++) {
      const value = this.readValue(lookupPath[index], source);

      if (!isNumber(value)) {
        if (!value) {
          // reading failed
          return null;
        }
      }

      // shall we have one more iteration?
      if (index + 1 < lookupPath.length) {
        source = value;
      }
      else {
        return value;
      }
    }
  }

  readValue(attrName: string, source: any): any {
    if (source instanceof Map) {
      return source.get(attrName);
    }
    return get(source, attrName);
  }
}
